// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1349":"44c397c9","3142":"44c397c9","4608":"44c397c9","8109":"44c397c9"}[chunkId] + ".chunk.css";
};